import { Typography } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';

export const MicrophonePermissionsRequiredErrorMessage = () => {
  return (
    <Flex alignItems="center" justifyContent="center">
      <Typography color="red">
        Please, allow browser to use your microphone
      </Typography>
    </Flex>
  );
};
